import React from 'react';
import {
  Box,
  Container,
  Typography,
  IconButton,
  Link as MuiLink,
  Stack,
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import LinkedInIcon from '@mui/icons-material/LinkedIn';

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: '#0d1b2a',
        color: '#fff',
        py: 4,
        mt: 6,
        borderTop: '4px solid #1565c0',
      }}
    >
      <Container maxWidth="lg">
        {/* Brand & Nav */}
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          justifyContent="space-between"
          alignItems="center"
          spacing={2}
        >
          {/* Branding */}
          <Typography variant="h6" fontWeight="bold">
            ProTechTion
          </Typography>

          {/* Navigation Links */}
          <Stack direction="row" spacing={3}>
            {[
              { label: 'Home', path: '/' },
              { label: 'Upload', path: '/upload' },
              { label: 'Search', path: '/search' },
              { label: 'Login', path: '/login' },
              { label: 'Register', path: '/register' },
            ].map((item, i) => (
              <MuiLink
                key={i}
                component={RouterLink}
                to={item.path}
                underline="hover"
                color="inherit"
                sx={{ fontSize: '0.9rem' }}
              >
                {item.label}
              </MuiLink>
            ))}
          </Stack>

          {/* Social Icons */}
          <Stack direction="row" spacing={1}>
            <IconButton
              component="a"
              href="https://facebook.com"
              target="_blank"
              rel="noopener noreferrer"
              color="inherit"
            >
              <FacebookIcon />
            </IconButton>
            <IconButton
              component="a"
              href="https://twitter.com"
              target="_blank"
              rel="noopener noreferrer"
              color="inherit"
            >
              <TwitterIcon />
            </IconButton>
            <IconButton
              component="a"
              href="https://linkedin.com"
              target="_blank"
              rel="noopener noreferrer"
              color="inherit"
            >
              <LinkedInIcon />
            </IconButton>
          </Stack>
        </Stack>

        {/* Copyright */}
        <Typography
          variant="body2"
          align="center"
          sx={{ mt: 4, fontSize: '0.8rem', opacity: 0.7 }}
        >
          &copy; {new Date().getFullYear()} ProTechTion. All rights reserved.
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;
